/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/documentdataextractor/DocumentDataExtractorUserGuidance.yaml
import { BackgroundStyle, StyledText } from '../common/Common';
/**
Configure the captions of the user guidance hints for different scanning states.
*/
export class DocumentDataExtractorGuidanceStates {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorGuidanceStates>`} */
    constructor(source = {}) {
        /**
          The user guidance text displayed when no document is found. Initial state.
          
          Default is "?documentUserGuidanceNoDocumentFound"
          */
        this.noDocumentFound = '?documentUserGuidanceNoDocumentFound';
        /**
          The user guidance text displayed when a document presence was detected and scanning is in progress.
          
          Default is "?documentUserGuidanceScanningProgress"
          */
        this.scanningProgress = '?documentUserGuidanceScanningProgress';
        /**
          The user guidance text displayed when it is too dark to capture an adequate image.
          
          Default is "?documentUserGuidanceTooDark"
          */
        this.tooDark = '?documentUserGuidanceTooDark';
        /**
          The user guidance text displayed when the detected document is too far away and appears too small.
          
          Default is "?documentUserGuidanceTooSmall"
          */
        this.tooSmall = '?documentUserGuidanceTooSmall';
        /**
          The user guidance text displayed when the detected document is not in a good perspective (device tilted).
          
          Default is "?documentUserGuidanceBadPerspective"
          */
        this.badPerspective = '?documentUserGuidanceBadPerspective';
        if (source.noDocumentFound !== undefined) {
            this.noDocumentFound = source.noDocumentFound;
        }
        if (source.scanningProgress !== undefined) {
            this.scanningProgress = source.scanningProgress;
        }
        if (source.tooDark !== undefined) {
            this.tooDark = source.tooDark;
        }
        if (source.tooSmall !== undefined) {
            this.tooSmall = source.tooSmall;
        }
        if (source.badPerspective !== undefined) {
            this.badPerspective = source.badPerspective;
        }
    }
}
/**
Configuration of the hints guiding users through the document scanning process.
*/
export class DocumentDataExtractorGuidanceConfiguration {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorGuidanceConfiguration>`} */
    constructor(source = {}) {
        /**
          Determines whether the user guidance hints should be visible (enabled).
          
          Default is true
          */
        this.visibility = true;
        /**
          Configure the text style for the user guidance hints.
          */
        this.title = new StyledText({
            text: '?documentUserGuidanceNoDocumentFound',
            color: '?sbColorOnPrimary',
        });
        /**
          Configure the background style for the user guidance hints.
          */
        this.background = new BackgroundStyle({
            strokeColor: '#00000000',
            fillColor: '?sbColorSurfaceLow',
        });
        /**
          Configure the captions of the user guidance hints for different states.
          */
        this.statesTitles = new DocumentDataExtractorGuidanceStates({});
        if (source.visibility !== undefined) {
            this.visibility = source.visibility;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
        if (source.statesTitles !== undefined) {
            this.statesTitles = new DocumentDataExtractorGuidanceStates(source.statesTitles);
        }
    }
}
//# sourceMappingURL=DocumentDataExtractorUserGuidance.js.map